// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__tA1CL","validationTips":"StatementDescriptor_validationTips__2psUc"};